<template>
  <div>
    <hr />
    <router-link v-if="!$router.currentRoute.path.startsWith('/conversations')" :to="{name:'myConversations'}">
      <mdb-btn class="brown lighten-1" rounded size="sm">Conversations</mdb-btn>
    </router-link>
    <router-link v-if="!$router.currentRoute.path.startsWith('/questions')" :to="{name:'allQuestions'}">
      <mdb-btn class="brown lighten-1" rounded size="sm">Questions</mdb-btn>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "InPageNav",
};
</script>

<style>
</style>